"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPreviewItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _videoBroken = _interopRequireDefault(require("b2b-components/theme/assets/images/video-broken.svg"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _Icon = require("b2b-components/theme/components/Icon");
var _Item = require("../Item");
var _ItemIcon = require("../ItemIcon");
var _ItemImage = require("../ItemImage");
var VideoPreviewItem = function VideoPreviewItem(_ref) {
  var title = _ref.title,
    _ref$video = _ref.video,
    imageUrl = _ref$video.imageUrl,
    link = _ref$video.link,
    className = _ref.className,
    isCurrent = _ref.isCurrent,
    isPreview = _ref.isPreview,
    onClick = _ref.onClick,
    totalItemCount = _ref.totalItemCount;
  return /*#__PURE__*/_react["default"].createElement(_Item.Item, {
    className: className,
    isCurrent: isCurrent,
    isPreview: isPreview,
    onClick: onClick,
    totalItemCount: totalItemCount,
    href: link,
    type: _Gallery.GALLERY_ITEM_TYPE.video
  }, /*#__PURE__*/_react["default"].createElement(_ItemImage.ItemImage, {
    src: imageUrl || _videoBroken["default"],
    title: title
  }), /*#__PURE__*/_react["default"].createElement(_ItemIcon.ItemIcon, null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.video
  })));
};
exports.VideoPreviewItem = VideoPreviewItem;